import { Component, Input } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { IrisP2PService, P2POrder } from 'src/app/services/iris-p2p.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-p2p-buy-modal',
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule],
  templateUrl: './p2p-buy-modal.component.html',
  styleUrls: ['./p2p-buy-modal.component.scss']
})
export class P2PBuyModalComponent {
  @Input() order!: P2POrder;
  @Input() isFr = false;

  amount: string = '';

  constructor(private modalCtrl: ModalController, public p2p: IrisP2PService) {}

  close(cancel = true) {
    this.modalCtrl.dismiss(null, cancel ? 'cancel' : 'confirm');
  }

  confirm() {
    const value = parseFloat(this.amount);
    this.modalCtrl.dismiss({ amount: value }, 'confirm');
  }

  get min(): number { return this.p2p.fromWeiNum(this.order.minBuy); }
  get max(): number { return this.p2p.fromWeiNum(this.order.remaining); }

  get parsedAmount(): number { return parseFloat(this.amount || '0'); }

  buyerPays(amount?: string): string {
    const a = amount ? parseFloat(amount) : parseFloat(this.amount || '0');
    if (!a || !this.order.rate) return '0';
    const raw = this.p2p.toWei(a.toString());
    return this.p2p.fiatAmountFromWei(raw, this.order.rate, this.order.currency || '', undefined);
  }
}
